interface EmptyStateProps {
  title?: string;
  description?: string;
  onReset?: () => void;
}

export default function EmptyState({
  title = "没有找到相关内容",
  description = "换个筛选条件或关键词试试吧。",
  onReset,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-center">
      <div className="w-16 h-16 flex items-center justify-center rounded-full bg-background-200 mb-5">
        <i className="ri-search-eye-line text-2xl text-foreground-400"></i>
      </div>
      <h3 className="text-lg font-medium text-foreground-900 font-heading">{title}</h3>
      <p className="mt-2 text-sm text-foreground-500 max-w-sm">{description}</p>
      {onReset && (
        <button
          type="button"
          onClick={onReset}
          className="mt-6 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          重置筛选条件
        </button>
      )}
    </div>
  );
}